import type { Components, Theme } from '@mui/material';

export const MuiDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.h2,
      marginTop: theme.spacing(1),
    }),
  },
};
